import {Component, Input, OnInit} from '@angular/core';
import {AppState, PaymentOverview, PaymentPlan, PaymentPlanType} from '../../state/AppState';
import {MortgageId, PaymentId, ScenarioId} from '../../domain/scenario.model';
import {Store} from '@ngrx/store';
import {RemovePayment, removePayment, UpdatePayment, updatePayment} from '../../state/effects.actions';
import {ListItem} from '../../common/ListItem';
import {toNumber} from '../../util/util';


@Component({
  selector: 'mortgage-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  title = 'mortgage payment component';
  private _amount: number;
  private _startAtMonth: number;
  private _planType: string;
  private _mortgageId: MortgageId;
  private paymentId: PaymentId;
  private _scenarioId: ScenarioId;
  public possiblePaymentTypes: ListItem[] = [
    {value: PaymentPlanType.ONCE.valueOf(), label: 'Once'},
    {value: PaymentPlanType.MONTHLY.valueOf(), label: 'Monthly'}
  ];

  @Input()
  set payment(payment: PaymentOverview) {
    this._amount = payment.plan.amount;
    this._startAtMonth = payment.plan.startAtMonth;
    this._planType = payment.plan.planType;
    this.paymentId = payment.paymentId; //FIXME: use a real poayment id
  }

  @Input()
  set mortgageId(mortgageId:MortgageId){
    this._mortgageId = mortgageId;
  }

  @Input()
  set scenarioId(scenarioId:ScenarioId){
    this._scenarioId = scenarioId;
  }

  toNumber = toNumber

  set amount(amount: number) {
    this._amount = amount;
  }

  get amount() {
    return this._amount;
  }

  set planType(planType: string) {
    this._planType = planType;
  }

  get planType() {
    return this._planType;
  }

  set startAtMonth(startAtMonth: number) {
    this._startAtMonth = startAtMonth;
  }

  get startAtMonth() {
    return this._startAtMonth;
  }

  constructor(private store: Store<AppState>) {
  }

  ngOnInit(): void {
    console.log('Init mortgage details')
  }

  submit(event: Event): void {
    event.preventDefault(); //no reload
    //
    // let contract: MortgageContract = {
    //   durationMonths: (this._durationInYears == null) ? null : this._durationInYears * 12,
    //   mortgagedAmount: this._mortgagedAmount,
    //   interestRate: this.interestRate,
    //   contractType: ContractType[this._contractType],
    //   principal: this._principal,
    //   monthlyPremium: this.premium
    // };





    this.store.dispatch(updatePayment(<UpdatePayment>{
      plan: <PaymentPlan>{
        planType: this._planType,
        startAtMonth: this._startAtMonth,
        amount: this._amount
      },
      mortgageId: this._mortgageId,
      paymentId: this.paymentId,
      scenarioId: this._scenarioId
    }));
  }

  remove() {
    this.store.dispatch(removePayment(<RemovePayment>{
      scenarioId: this._scenarioId,
      mortgageId: this._mortgageId,
      paymentId: this.paymentId
    }));
  }
}
